import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';
import PhotoRoundedIcon from '@mui/icons-material/PhotoRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import GridOnRoundedIcon from '@mui/icons-material/GridOnRounded';
import PresentToAllRoundedIcon from '@mui/icons-material/PresentToAllRounded';
import VideocamRoundedIcon from '@mui/icons-material/VideocamRounded';
import AudiotrackRoundedIcon from '@mui/icons-material/AudiotrackRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

interface MFile {
    url: string;
}

type NullableString = string | null;

export function getFileExtension(file:MFile):NullableString {
    if(!file || !file.url)
    {
        return null;
    }
    else
    {
        var extSplit = file.url.split('?')[0].split('.');
        return extSplit[extSplit.length - 1].toLowerCase();
    }
}

export function isImage(file:MFile):boolean {
    var ext;
    if(!file || !file.url)
    {
        ext = '';
    }
    else
    {
        var extSplit = file.url.split('?')[0].split('.');
        ext = extSplit[extSplit.length - 1].toLowerCase();
    }

    return (ext == 'jpg' || ext == 'jpeg' || ext == 'png' || ext =='tiff' || ext == 'bmp' || ext == 'gif');
};

export function getFileExtensionIcon(file:MFile) {
    var ext;
    if(!file || !file.url)
    {
        ext = '';
    }
    else
    {
        var extSplit = file.url.split('?')[0].split('.');
        ext = extSplit[extSplit.length - 1].toLowerCase();
    }

    switch(ext)
    {
        // images
        case 'ai':
        case 'bmp':
        case 'eps':
        case 'gif':
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'psb':
        case 'psd':
        case 'svg':
        case 'svgz':
        case 'tiff':
            return <PhotoRoundedIcon/>;

        // text docs
        case 'doc':
        case 'docx':
        case 'indd':
        case 'odt':
        case 'pages':
        case 'pdf':
        case 'rtf':
        case 'txt':
            return <DescriptionRoundedIcon/>;

        // spreadsheet docs
        case 'csv':
        case 'numbers':
        case 'ods':
        case 'tsv':
        case 'xls':
        case 'xlsx':
            return <GridOnRoundedIcon/>;

        // presentation docs
        case 'key':
        case 'keynote':
        case 'odp':
        case 'ppt':
        case 'pptx':
            return <PresentToAllRoundedIcon/>;

        // video
        case 'avi':
        case 'flv':
        case 'm4v':
        case 'mkv':
        case 'mov':
        case 'mp4':
        case 'mpg':
        case 'ogv':
        case 'webm':
        case 'wmv':
            return <VideocamRoundedIcon/>;

        // audio
        case 'aac':
        case 'flac':
        case 'm4a':
        case 'm4p':
        case 'mp3':
        case 'oga':
        case 'wav':
        case 'wma':
            return <AudiotrackRoundedIcon/>;

        // web
        case 'asp':
        case 'aspx':
        case 'htm':
        case 'html':
        case 'php':
        case 'webloc':
            return <OpenInNewRoundedIcon/>
    }

    return (<InsertDriveFileRoundedIcon/>);
};

// todo: rework this to use file
function getDownloadLink(link:string, name:string) {
    var url = window.location.protocol + '//' + window.location.host + '/download-file?';

    // encode the url if we're on a browser that supports it (not IE)
    if(typeof window.btoa !== 'undefined')
    {
        url += 'slug=' + btoa(encodeURIComponent('url='+link+'&name='+name));
    }
    else
    {
        url += 'url='+encodeURIComponent(link)+'&name='+encodeURIComponent(name);
    }

    return url;
};
